import { css } from 'styled-components';

export const roundSelectionIndicatorStyles = css<{ $selected?: boolean }>`
  ${({ theme, $selected }) => css`
    &::before {
      content: ' ';
      box-sizing: border-box;
      position: absolute;
      top: 50%;
      left: 0;
      width: 24px;
      height: 24px;
      margin: -12px ${theme.spacing.x.xs} 0 0;
      background: ${theme.colors.neutral[0]};
      border: ${$selected
        ? `7px solid ${theme.colors.background.component['input-elements']['active-default']}`
        : `${theme.borders.width.xs} solid ${theme.colors.border.component['input-elements'].rest}`};
      border-radius: 50%;
    }
  `}
`;
